import { CAMPAIGNS_API } from 'modules/campaigns/api/constants'
import {
  CampaignCreateInterface,
  CampaignId,
  CampaignInterface,
  CampaignUpdateInterface,
} from 'modules/campaigns/types/campaign-interface'
import httpClient from 'shared/utils/http-client'

export const removeCampaign = (id: CampaignId) => httpClient.delete(`${CAMPAIGNS_API}/${id}`)

export const createCampaign = (data: CampaignCreateInterface) =>
  httpClient.post<CampaignInterface>(CAMPAIGNS_API, data)

export const updateCampaign = (id: CampaignId, data: CampaignUpdateInterface) =>
  httpClient.put<CampaignInterface>(`${CAMPAIGNS_API}/${id}`, data)

export const duplicateCampaign = (id: CampaignId) =>
  httpClient.post<CampaignInterface>(`${CAMPAIGNS_API}/duplicate/${id}`)

export const shareCampaign = (id: CampaignId) =>
  httpClient.post<string>(`${CAMPAIGNS_API}/share/${id}`)
